const refundPolicy = [
    {
        id: "overview",
        title: "1. Overview",
        content: "At AS Designs Galaxy, we sell digital products including HTML and React website templates. Due to the nature of digital downloads, all sales are generally final once the product has been accessed or downloaded. By purchasing from our website, you agree to this Refund Policy."
    },
    {
        id: "no-refund",
        title: "2. No Refund Policy",
        content: "All purchases of digital products are non-refundable once the product has been delivered or downloaded. Since digital files cannot be returned, we do not offer refunds, exchanges, or cancellations after purchase."
    },
    {
        id: "exceptions",
        title: "3. Exceptions (Limited Cases Only)",
        content: "Refunds may be considered only under the following conditions:",
        list: [
            "Product was not delivered after successful payment",
            "Major technical issue that makes the template unusable",
            "Product is significantly different from its description or live demo"
        ]
    },
    {
        id: "non-refundable",
        title: "4. Non-Refundable Situations",
        content: "Refunds will NOT be provided in the following situations:",
        list: [
            "Change of mind after purchase",
            "Lack of technical knowledge to use the product",
            "Product does not meet personal expectations",
            "Purchased by mistake",
            "Expecting features not listed in the description",
            "Compatibility issues with third-party tools not mentioned"
        ]
    },
    {
        id: "support",
        title: "5. Support Commitment",
        content: "Before requesting a refund, we encourage you to contact us. We are happy to assist with installation guidance, basic usage support, and fixing issues related to the original template."
    },
    {
        id: "payment",
        title: "6. Payment Processing",
        content: "All payments are securely processed through Lemon Squeezy. Billing-related concerns may also be subject to their policies."
    },
    {
        id: "contact",
        title: "7. Contact Us",
        content: "For refund requests or questions, please contact us at asdesigns632@gmail.com. We aim to respond within 24 hours."
    },
    {
        id: "updates",
        title: "8. Policy Updates",
        content: "We reserve the right to update or modify this Refund Policy at any time without prior notice."
    }
];

export default refundPolicy;